export default "__VITE_ASSET__DFs6$YT8__"